import request from './request';

// 获取我拥有的头衔
export function getMyTitles() {
  return request.get('/api/title/myTitles');
}

// 守护管理（专属主播）
export function getGuardList(anchorId) {
  const params = {};
  if (anchorId) params.anchor_id = anchorId;
  return request.get('/api/title/guardList', { params });
}
export function buyGuard(level, anchorId) {
  return request.post('/api/title/buyGuard', { level, anchor_id: anchorId });
}
export function getMyGuardAnchors() {
  return request.get('/api/title/myGuardAnchors');
}

// 粉丝徽章
export function getMyBadges() {
  return request.get('/api/title/myBadges');
}

// 公会管理
export function getMyGuild() {
  return request.get('/api/title/myGuild');
}
export function searchGuild(keyword) {
  return request.get('/api/title/searchGuild', { params: { keyword } });
}
export function joinGuild(guildId) {
  return request.post('/api/title/joinGuild', { guild_id: guildId });
}
export function exitGuild() {
  return request.post('/api/title/exitGuild');
}

// 公会管理
export function createGuild(data) {
  return request.post('/api/title/createGuild', data);
}
export function getGuildDetail(guildId) {
  return request.get('/api/title/guildDetail', { params: { guild_id: guildId } });
}
export function getGuildMembers(params) {
  return request.get('/api/title/guildMembers', { params });
}
export function removeGuildMember(guildId, userId) {
  return request.post('/api/title/removeGuildMember', { guild_id: guildId, user_id: userId });
}
export function disbandGuild(guildId) {
  return request.post('/api/title/disbandGuild', { guild_id: guildId });
}
export function transferLeader(guildId, newLeaderId) {
  return request.post('/api/title/transferLeader', { guild_id: guildId, new_leader_id: newLeaderId });
}

// 公会贵宾
export function getVipList() {
  return request.get('/api/title/vipList');
}

// 粉丝团
export function joinFanClub(roomId) {
  return request.post('/api/title/joinFanClub', { room_id: roomId });
}
export function upgradeBadge(roomId) {
  return request.post('/api/title/upgradeBadge', { room_id: roomId });
}
